export const PRIORITY_KEYS = {
    base: 'priorities',
    all: ['priorities'],
    list: ['priorities', 'list'],
} as const;
